export const FileFormat = {
  PDF: 0,
  CSV: 1,
}
